export default "__VITE_ASSET__BeIErvVE__"